<template>
  <div class="main-con-panel">
    <el-table
      :data="menuTable"
      style="width: 100%"
      ref="tableDom"
      row-key="Id"
      border
      lazy
      :load="loadChildMenu"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="MenuName" label="菜单名称"></el-table-column>
      <el-table-column prop="ControllerName" label="控制器名称"></el-table-column>
      <el-table-column prop="ActionName" label="动作名称"></el-table-column>
      <el-table-column label="菜单类型" width="80">
        <template slot-scope="scope">{{scope.row.MenuType | keyToVal(menuType)}}</template>
      </el-table-column>
      <el-table-column label="状态" width="60">
        <template slot-scope="scope">{{scope.row.Status | keyToVal(normalStatus)}}</template>
      </el-table-column>
      <el-table-column label="操作" width="290">
        <template slot-scope="scope">
          <el-row>
            <el-popconfirm
              v-if="scope.row.Pid!=='00000000-0000-0000-0001-000000000000'"
              title="确认删除这个菜单吗，此操作不可恢复并且将删除其子菜单？"
              v-on:onConfirm="upDateStatus(scope.row,'delete')"
            >
              <el-button size="mini" type="danger" slot="reference">删除</el-button>
            </el-popconfirm>
            <el-popconfirm
              v-if="scope.row.Status===0&&scope.row.Pid!=='00000000-0000-0000-0001-000000000000'"
              title="确认禁用这个菜单吗，此操作将同时禁用其子菜单？"
              v-on:onConfirm="upDateStatus(scope.row,'disable')"
            >
              <el-button size="mini" type="warning" slot="reference">禁用</el-button>
            </el-popconfirm>
            <el-popconfirm
              v-if="scope.row.Status===1&&scope.row.Pid!=='00000000-0000-0000-0001-000000000000'"
              title="确认启用这个菜单吗，此操作不会同步启用其子菜单？"
              v-on:onConfirm="upDateStatus(scope.row,'enable',)"
            >
              <el-button size="mini" type="warning" slot="reference">启用</el-button>
            </el-popconfirm>
            <el-button
              v-if="scope.row.Status===0 &&scope.row.Pid!=='00000000-0000-0000-0001-000000000000'"
              v-on:click="editMenu(scope.row)"
              size="mini"
              type="primary"
            >编辑</el-button>
            <el-button
              v-on:click="addMenu(scope.row)"
              size="mini"
              type="success"
              v-if="scope.row.MenuType !== 'PAGE' && scope.row.MenuType !== 'BUTTON'"
            >新增子级</el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑 -->
    <el-dialog
      @close="closeDialog"
      :title="model.title"
      :visible.sync="model.modelDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form ref="form" :model="model.form" :rules="model.rules" label-width="120px">
        <el-form-item label="菜单名称" prop="MenuName" required>
          <el-input v-model="model.form.MenuName"></el-input>
        </el-form-item>
        <el-form-item label="控制器名称" prop="ControllerName">
          <el-input v-model="model.form.ControllerName"></el-input>
        </el-form-item>
        <el-form-item label="动作名称" prop="ActionName">
          <el-input v-model="model.form.ActionName"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="MenuType" required>
          <el-select v-model="model.form.MenuType" placeholder="请选择菜单类型">
            <el-option :label="item.val" :value="item.key" :key="item.key" v-for="item in menuType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图标" prop="Icon">
          <el-input v-model="model.form.Icon"></el-input>
        </el-form-item>
        <el-form-item label="是否打开新页面" prop="OpenNewPage" required>
          <el-select v-model="model.form.OpenNewPage" placeholder="请选择">
            <el-option :label="item.val" :value="item.key" :key="item.key" v-for="item in isOrNo"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="OrderNum" required>
          <el-input-number v-model="model.form.OrderNum" :min="1" :max="20" label="请输入"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="Status" required>
          <el-select v-model="model.form.Status" placeholder="请选择菜单状态">
            <el-option
              :label="item.val"
              :value="item.key"
              :key="item.key"
              v-for="item in normalStatus"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="model.modelDialog = false">取 消</el-button>
        <el-button type="primary" @click="postModel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { GetRoleTree, GetMenuTypes, AddMenu, ChangeMenu } from "@/api/roleTree";
import account from "@/api/common";
import { keyToVal } from "@/filters/filters";
import { mapState } from "vuex";
export default {
  name: "MenuManage",
  data: function () {
    return {
      //表格数据
      menuTable: [],
      //编辑窗口表单内容
      model: {
        title: "",
        actionType: "",
        modelDialog: false,
        rules: {
          MenuName: [
            { required: true, message: "请输入菜单名", trigger: "blur" },
          ],
          MenuType: [
            { required: true, message: "请选择菜单类型", trigger: "blur" },
          ],
        },
        form: {
          Id: "",
          Pid: "",
          MenuName: "",
          ControllerName: "",
          ActionName: "",
          MenuType: "",
          Icon: "",
          OrderNum: 1,
          Status: 0,
          OpenNewPage: false,
        },
      },
      //修复添加时菜单节点没有子节点的更新情况
      editRow: null,
      //修复懒加载删除叶结点缓存问题
      maps: new Map(),
    };
  },
  inject: ["deepClone"],
  filters: {
    keyToVal,
  },
  computed: {
    ...mapState("common", ["menuType", "isOrNo", "normalStatus", "actionMap"]),
  },
  methods: {
    getMenu(pid) {
      if (typeof pid === "undefined") {
        pid = "00000000-0000-0000-0001-000000000000"; //获取根节点
      }
      account.getMenu(pid).then((res) => {
        if (res.status === "success") {
          this.menuTable = res.content;
          // this.$set(this, "menuTable", res.content);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    loadChildMenu(tree, treeNode, resolve) {
      const pId = tree.Id;
      this.maps.set(pId, { tree, treeNode, resolve });
      account.getMenu(tree.Id).then((res) => {
        if (res.status === "success") {
          treeNode.children = res.content;
          resolve(treeNode.children);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //删 禁 启
    upDateStatus(menu, action) {
      const status = this.actionMap[action];
      if (typeof status !== "undefined") {
        menu.Status = status;

        account.changeMenu(menu).then((res) => {
          if (res.status === "success") {
            this.$message.success(res.msg);
            this.renderLazyTable(menu.Pid);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    //新增子级
    addMenu(row) {
      this.editRow = row;
      this.model.title = "新增菜单";
      this.model.actionType = "add";
      this.model.form.Pid = row.Id;
      this.model.modelDialog = true;
    },
    //编辑菜单
    editMenu(menu) {
      this.model.title = "编辑菜单";
      this.model.actionType = "edit";
      this.model.modelDialog = true;
      this.model.form = this.deepClone(menu);
      this.editRow = menu;
    },
    //提交模型
    postModel() {
      this.$refs.form.validate((success) => {
        if (success) {
          if (this.model.actionType === "add") {
            account.addMenu(this.model.form).then((res) => {
              if (res.status === "success") {
                this.$message.success(res.msg);
                let pId = this.editRow.hasChildren
                  ? this.editRow.Id
                  : this.editRow.Pid;
                this.renderLazyTable(pId);
                this.model.modelDialog = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            account.changeMenu(this.model.form).then((res) => {
              if (res.status === "success") {
                this.$message.success(res.msg);
                this.renderLazyTable(this.editRow.Pid);
                this.model.modelDialog = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          this.$message.error("请补全信息");
        }
      });
    },
    closeDialog() {
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.model.form = {
        Id: "",
        Pid: "",
        MenuName: "",
        ControllerName: "",
        ActionName: "",
        MenuType: "",
        Icon: "",
        OrderNum: 1,
        Status: 0,
        OpenNewPage: false,
      };
    },
    //重新渲染懒加载的表格数据
    renderLazyTable(pid) {
      const { tree, treeNode, resolve } = this.maps.get(pid);
      this.$set(this.$refs.tableDom.store.states.lazyTreeNodeMap, pid, []); //强制更新视图
      this.loadChildMenu(tree, treeNode, resolve); //懒加载局部动态更新
    },
  },
  created() {
    this.getMenu();
  },
  mounted() {},
};
</script>


<style scoped>
.function-bar {
  margin-top: 10px;
  margin-bottom: 10px;
}
#main-page {
  display: flex;
  justify-content: space-between;
}

#main-page > div:nth-of-type(1) {
  flex: 0 0 30%;
}

#main-page > div:nth-of-type(2) {
  flex: 1;
}

#main-page > div:nth-of-type(2) > div:nth-of-type(1) {
  width: 70%;
  min-width: 700px;
}

.el-textarea .el-input__count {
  line-height: 2;
}

.el-dialog__body > span {
  font-size: 16px;
}

.el-input.is-disabled >>> .el-input__inner {
  color: #666666;
}
.el-select >>> .is-disabled .el-input__inner {
  color: #666666;
}
</style>>